<template>
  <div id="app">
    <div id="navbar">     
    </div>
    <router-view/>
  </div>
</template>

<script>
import './style.scss'
export default {
  
}
</script>>

<style lang="scss">

</style>
